import React from 'react';
import {
  Card, CardContent, Typography, Avatar, Box, Button
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import WorkIcon from '@mui/icons-material/Work';
import EventIcon from '@mui/icons-material/Event';
import '../../Recruteur/Dashboard/MissionsList.css'; 
import '../../commun/StatusTabs.css'
import { recruteurCandidatureStatus } from '../../commun/constants/options';

const CandidaturesList = ({ candidatures = [], onView = () => {} }) => {
  const lastCandidatures = candidatures.slice(0, 4);
  return (
    <div className="missions-list-compact">
      {lastCandidatures.map((c, i) => {
        const rawStatus = c.statut || 'Inconnu';
        const matchedStatus = recruteurCandidatureStatus.find((s) => s.value.toLowerCase() === rawStatus.toLowerCase());
        return (
          <Card key={i} className="mission-compact-card" elevation={1}>
            <CardContent className="mission-compact-content">
              <Avatar className="mission-compact-avatar">
                <PersonIcon />
              </Avatar>

              <Box className="mission-compact-info">
              <Typography
                variant="subtitle1"
                className="mission-title"
                noWrap
                onClick={() => onView(c._id || c.idCandidature)}
                style={{ cursor: 'pointer', color: '#1976d2' }}
              >
                {c.reference || 'N/A'}
              </Typography>

                <Box className="company-row">
                  <WorkIcon fontSize="small" className="icon-small" />
                  <Typography variant="subtitle2" className="company-name" noWrap>
                    {c.missionTitre || 'Mission inconnue'}
                  </Typography>
                </Box>

                <Box className="company-row">
                <PersonIcon fontSize="small" className="icon-small" />
                <Typography variant="subtitle2" className="company-name" noWrap>
                    {c.recruteur.utilisateur.firstName} {c.recruteur.utilisateur.lastName}
                  </Typography>
                </Box>

                <Box className="meta-row">
                  <EventIcon fontSize="small" className="icon-small" />
                  <Typography variant="caption" className="meta-text" noWrap>
                    {c.dateCandidature && !isNaN(new Date(c.dateCandidature))
                      ? new Date(c.dateCandidature).toLocaleString()
                      : '—'}
                  </Typography>
                </Box>

                {/* 2. Statut stylé */}
                {/* <Typography variant="body2">
                  Statut :{' '}
                  <span className="status-cell" style={matchedStatus?.style}>
                    {rawStatus === 'A traiter'
                      ? 'Candidature envoyée'
                      : matchedStatus?.label || rawStatus}
                  </span>
                </Typography> */}
              </Box>

              <Box className="prime-and-btn">
                {/* <Button
                  variant="outlined"
                  size="small"
                  className="details-btn"
                  onClick={() => onView(c._id || c.idCandidature)}
                >
                  Détails
                </Button> */}
                <span className="status-cell" style={matchedStatus?.style}>
                  {rawStatus === 'A traiter'
                    ? 'Candidature à traiter'
                    : matchedStatus?.label || rawStatus}
                </span>
              </Box>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default CandidaturesList;
